<template>
  <div :class="classNames" draggable="false" ref="container">
    <div class="layout__split-master" ref="master">
      <slot></slot>
    </div>
    <transition :name="transition">
      <div
        class="layout__split-detail"
        ref="detail"
        v-if="isDetailVisible">
        <slot name="detail"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import {
  SET_DRAWER_VISIBILITY
} from '@/modules/mutation-types'

export default {
  computed: {
    classNames () {
      let o = {
        'layout__split': true,
        'layout__split--fullscreen': this.displayMode === 'primaryHidden',
        'layout__split--primary-hidden': this.displayMode === 'primaryHidden',
        'layout__split--collapsed': this.isCollapsed
      }
      o[`layout__detail-origin--${this.origin}`] = true
      return o
    },
    isCollapsed () {
      return this.$store.state.device.sizeClass === 'compact'
    },
    isDetailVisible () {
      if (this.$store.state.device.sizeClass === 'regular') return true
      return this.showDetail
    },
    transition () {
      return `slide__${this.origin}`
    }
  },
  data () {
    return {
      touch: {
        swipeThreshold: 10,
        startX: null,
        startY: null
      }
    }
  },
  methods: {
    onTouchStart (ev) {
      this.touch.startX = ev.touches[0].clientX
      this.touch.startY = ev.touches[0].clientY
    },
    onTouchMove (ev) {
      this.touch.endX = ev.touches[0].clientX
      this.touch.endY = ev.touches[0].clientY
    },
    onTouchEnd (ev) {
      if (!this.touch.startX || !this.touch.startY || !this.touch.endX || !this.touch.endY) return
      if (this.$store.state.device.sizeClass === 'compact') return

      let [disH, disV] = [this.touch.startX - this.touch.endX, this.touch.startY - this.touch.endY]
      let [h, v] = [disH, disV].map(Math.abs)
      let d = this.touch.swipeThreshold
      if (v > d) return // vertical swipe, we don't care about for this
      if (h > d) { // horizontal swipe
        let swipeEventString = (this.touch.startX < this.touch.endX) ? 'swipeRight' : 'swipeLeft'
        // swipeLeft
        if (swipeEventString === 'swipeLeft' && this.displayMode !== 'primaryHidden') {
          if (this.$store.state.app.drawer.visibility === 'visible') {
            this.$store.commit(SET_DRAWER_VISIBILITY, { visibility: 'hidden' })
          } else {
            this.$parent.hidePrimaryHandler()
          }
        }
        // swipeRight
        if (swipeEventString === 'swipeRight') {
          this.displayMode === 'primaryHidden'
            ? this.$parent.showPrimaryHandler()
            : this.$store.commit(SET_DRAWER_VISIBILITY, { visibility: 'visible' })
        }
      }
      this.touch.startX = null
      this.touch.startY = null
      this.touch.endX = null
      this.touch.endY = null
    }
  },
  mounted () {
    let container = this.$refs.container
    container.addEventListener('touchmove', this.onTouchMove, { passive: true })
    container.addEventListener('touchstart', this.onTouchStart, { passive: true })
    container.addEventListener('touchend', this.onTouchEnd, { passive: true })
  },
  destroyed () {
    let container = this.$refs.container
    if (container) {
      container.removeEventListener('touchmove', this.onTouchMove)
      container.removeEventListener('touchstart', this.onTouchStart)
      container.removeEventListener('touchend', this.onTouchEnd)
    }
  },
  props: {
    showDetail: {
      default: false,
      type: Boolean
    },
    displayMode: {
      default: 'adjacent',
      type: String
    },
    origin: {
      default: 'right',
      type: String
    },
    preferredDisplayMode: {
      default: null,
      type: String
    },
    willSwipe: {
      default: false,
      type: Boolean
    }
  }
}
</script>

<style lang="sass">
@import "../styles/variables.scss"

.device__viewport-class--compact
  .slide__left-enter-active, .slide__left-leave-active
    transition: transform $sheetSpeed $animationTimingFunction
  .slide__left-enter, .slide__left-leave-to
    transform: translateX(100%)
  .slide__left-enter-to, .slide__left-leave
    transform: translateX(0)
  .slide__bottom-enter-active, .slide__bottom-leave-active
    transition: transform $sheetSpeed $animationTimingFunction
  .slide__bottom-enter, .slide__bottom-leave-to
    transform: translateY(100%)
  .slide__bottom-enter-to, .slide__bottom-leave
    transform: translateY(0)

.layout__split-detail, .layout__split-master
  bottom: 0
  right: 0
  top: 0
  left: 0
  position: absolute
.layout__split-detail
  background: #fff
  left: 320px
  transition: left $sheetSpeed $animationTimingFunction
  z-index: 2
  .device__viewport-class--regular &
    border-left: $layoutBorder
  .device__viewport-class--regular.app__drawer--visible &
    min-width: 750px
    width: calc(100vw - 320px - 250px)
  .device__viewport-class--compact &
    box-shadow: -2px -1px 10px rgba(0, 0, 0, 0.26)
    top: 0
    left: 0
    width: 100%
    z-index: 1000
  .layout__split--fullscreen &
    left: 0
    top: 0
    .device__viewport-class--regular &
      left: -1px
.layout__split-master
  left: 0
  width: $SplitLayoutMasterWidth
  min-width: $SplitLayoutMasterWidth
  .device__viewport-class--compact &
    border: none
    width: 100%
  // .layout__content-body
  //   .mui-app:not(.device__platform--ios) &
  //     margin-right: 8px
  // .layout__split--fullscreen &
  //   left: -$SplitLayoutMasterWidth
</style>



// WEBPACK FOOTER //
// src/layouts/SplitLayout.vue